// @link https://synergy.ccos.dev/pages/viewpage.action?pageId=178719920#id-[%EA%B0%9C%EB%B0%9C%EA%B0%80%EC%9D%B4%EB%93%9C]ICTWebViewStandardSpec(App%E2%86%94Web%EC%97%B0%EB%8F%99)(v0.9.6)-4.FEJavascriptFunction%EA%B5%AC%ED%98%84%ED%95%AD%EB%AA%A9(%EC%84%A0%ED%83%9D)|APP%E2%86%92WEB%ED%98%B8%EC%B6%9C
declare global {
  interface Window {
    onWebViewClose(): void; // TODO: 이 훅이 존재만 해도 동작이 달라져서 사용처에서 직접 구현하여 사용해야함

    onBackButton(): void; // TODO: 이 훅이 존재만 해도 동작이 달라져서 사용처에서 직접 구현하여 사용해야함

    onLifeCycle(state: LifeCycleState): void;

    bottomSheetClose(props?: unknown): void;

    closePresentationWindow(props?: unknown): void;
  }
}

export interface LifeCycleListener {
  (state: LifeCycleState): void;
}

export enum LifeCycleState {
  BACKGROUND = 'background', // 앱이 background로 내려갈때 호출
  FOREGROUND = 'foreground', // 앱이 foreground로 올라올때 호출
  DESTROY = 'destroy', // 웹뷰가 종료될때(닫힐때) 호출
  RESUME = 'resume', // 화면에 진입(나타날)때마다 호출
  PAUSE = 'pause', // 화면에서 사라질때 마다 호출
}

let lifeCycleListener: Array<LifeCycleListener> = [];

window.onLifeCycle = (state) => {
  lifeCycleListener.forEach((listener) => listener(state));
};

export function addLifeCycleListener(listener: LifeCycleListener) {
  lifeCycleListener.push(listener);
}

export function removeLifeCycleListener(listener: LifeCycleListener) {
  lifeCycleListener = lifeCycleListener.filter((l) => l !== listener);
}
